import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchNotificationsFailure, fetchNotificationsSuccess } from "domains/notifications/actions";
import type { FetchNotificationsDefaultAction } from "domains/notifications/actionTypes";
import type { NotificationPayload } from "domains/notifications/types";

export const NOTIFICATION_LIMIT = 20;

export function* fetchNotificationsSaga(action: FetchNotificationsDefaultAction) {
  try {
    const notifications: NotificationPayload = yield apiFetch("notification", {
      queryParams: {
        offset: action.meta.offset * NOTIFICATION_LIMIT,
        limit: NOTIFICATION_LIMIT,
      },
    });
    yield put(fetchNotificationsSuccess(action.meta, notifications));
  } catch {
    yield put(fetchNotificationsFailure({ logoutOnAuthError: true }));
  }
}
